/* eslint-disable no-param-reassign */
import { ParamsHelper } from '../../helpers/ParamsHelper';
import { CommonHelper } from '../../helpers/CommonHelper';
import { ApiHttpService } from '../ApiHttpService';
import { PaymentTypeSerializer } from '../serializers/PaymentTypeSerializer';
import { PaymentType } from '../../models/PaymentType';

const PAYMENT_TYPE_PATH = 'usuario/TextosFormasDePagoPedido/';

class PaymentTypeController {
  static async all(purchaseType) {
    const authenticated = true;
    const parameters = ParamsHelper.createQueryParams({
      tipoCompra: purchaseType,
    });
    const response = await ApiHttpService.get(`${PAYMENT_TYPE_PATH}${parameters}`, {}, authenticated);
    const deSerializedData = CommonHelper
      .moveByIdToFirstPosition(response.data.map(PaymentTypeSerializer.deSerialize), 4);
    let paymentMethods = deSerializedData.map(data => new PaymentType(data));
    paymentMethods = paymentMethods.map((x) => {
      if (x.id === 4 && x.references) {
        x.description = 'Pago con banco o tarjeta prepaga';
        const order = ['113', '001', '137', '153', '128', '157', '1119'];
        const bancosOrdenados = x.references
          .sort((a, b) => order.indexOf(a.code) - order.indexOf(b.code));
        x.references = bancosOrdenados;
        return x;
      }
      return x;
    });
    return paymentMethods;
  }
}

export { PaymentTypeController };



// WEBPACK FOOTER //
// ./src/networking/controllers/PaymentTypeController.js